import React from 'react';
import PropTypes from 'prop-types';
import List from '@dc/ui-library/src/molecules/List/List';
import ClosableTooltip from '@dc/ui-library/src/organisms/ClosableTooltip/ClosableTooltip';

import CompareProductPriceBlock from './CompareProductPriceBlock.jsx';

function ComparePanelProductTooltip(props) {

  const {
    display, productUrl, title, imageUrl, imageAlt, price, brand,
    onCloseButtonClick, onClickOutsideOfTooltip, onScroll, isComboKit,
    isOutOfStock, savingsPrice, wasPrice, mainProductCurrentPrice, mainProductWasPrice,
    comboKitItemNames, onEmailMeBackLinkClicked, separateSellingPrice, showEmailMeBack,
    translations, wasPriceFrom, wasPriceTo
  } = props;

  const mainComponentClass = display ? 'dc-compare-panel-product-tooltip'
    : 'dc-compare-panel-product-tooltip--hidden';

  return (
    <div className={mainComponentClass}>
      <ClosableTooltip
        arrow="top"
        onCloseButtonClick={onCloseButtonClick}
        onClickOutsideOfTooltip={onClickOutsideOfTooltip}
        onScroll={onScroll}
        display={display}
        type="neutral"
      >
        <a href={productUrl} className="dc-compare-panel-product-tooltip__product-link">
          <div className="dc-compare-panel-product-tooltip__product-link-wrapper">
            <span href={productUrl} className="dc-compare-panel-product-tooltip__name">
              {brand} {title}
            </span>
            {isComboKit &&
            <div className="dc-compare-panel-product-tooltip__bundle-list">
              <List
                items={comboKitItemNames}
                icon="PlusCircle"
              />
            </div>
            }
            <div className="dc-compare-panel-product-tooltip__bottom-part-flexbox-wrapper">
              <div className="dc-compare-panel-product-tooltip__image">
                <img src={imageUrl} alt={imageAlt} />
              </div>
              <div className="dc-compare-panel-product-tooltip__right-panel">
                <CompareProductPriceBlock
                  isComboKit={isComboKit}
                  isOutOfStock={isOutOfStock}
                  mainProductCurrentPrice={mainProductCurrentPrice}
                  mainProductWasPrice={mainProductWasPrice}
                  price={price}
                  savingsPrice={savingsPrice}
                  translations={translations}
                  wasPrice={wasPrice}
                  wasPriceFrom={wasPriceFrom}
                  wasPriceTo={wasPriceTo}
                />
                {isOutOfStock &&
                <div className="dc-compare-panel-product-tooltip__right-panel__out-of-stock">
                  <List
                    items={[props.translations.emailMeBackFirstLineTranslation]}
                    icon="Cross"
                  />
                </div>
                }
                {showEmailMeBack &&
                <div
                  className="dc-compare-panel-product-tooltip__right-panel__email-me-back"
                  onClick={onEmailMeBackLinkClicked}
                >
                  <List
                    items={[props.translations.emailMeBackLinkTranslation]}
                    icon="Mail"
                  />
                </div>
                }
                {separateSellingPrice &&
                <div
                  className="dc-compare-panel-product-tooltip__right-panel__separate-sell-price"
                >
                  {`${props.translations.separateSellingPriceTranslation} ${separateSellingPrice}`}
                </div>
                }
              </div>
            </div>
          </div>
        </a>
      </ClosableTooltip>
    </div>
  );
}

ComparePanelProductTooltip.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  productUrl: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    emailMeBackFirstLineTranslation: PropTypes.string.isRequired,
    emailMeBackLinkTranslation: PropTypes.string.isRequired,
    separateSellingPriceTranslation: PropTypes.string.isRequired
  }).isRequired,
  comboKitItemNames: PropTypes.arrayOf(PropTypes.string),
  display: PropTypes.bool,
  imageAlt: PropTypes.string,
  isOutOfStock: PropTypes.bool,
  isComboKit: PropTypes.bool,
  mainProductCurrentPrice: PropTypes.string,
  mainProductWasPrice: PropTypes.string,
  onCloseButtonClick: PropTypes.func,
  onClickOutsideOfTooltip: PropTypes.func,
  onEmailMeBackLinkClicked: PropTypes.func,
  onScroll: PropTypes.func,
  brand: PropTypes.string,
  savingsPrice: PropTypes.string,
  separateSellingPrice: PropTypes.string,
  showEmailMeBack: PropTypes.bool,
  wasPrice: PropTypes.string,
  wasPriceFrom: PropTypes.string,
  wasPriceTo: PropTypes.string
};

ComparePanelProductTooltip.defaultProps = {
  comboKitItemNames: [],
  display: true,
  imageAlt: '',
  isOutOfStock: false,
  isComboKit: false,
  mainProductCurrentPrice: undefined,
  mainProductWasPrice: undefined,
  onCloseButtonClick: () => {},
  onClickOutsideOfTooltip: () => {},
  onEmailMeBackLinkClicked: (e) => {
    e.preventDefault();
  },
  onScroll: () => {},
  brand: undefined,
  savingsPrice: undefined,
  separateSellingPrice: undefined,
  showEmailMeBack: false,
  wasPrice: undefined,
  wasPriceFrom: undefined,
  wasPriceTo: undefined
};

export default ComparePanelProductTooltip;
